import { Component, OnInit, TemplateRef} from '@angular/core';
import { ContentService } from '../../shared/content.service';

import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-dla demo-modal-sizes',
  templateUrl: './dla.component.html',
  styleUrls: ['./dla.component.scss'],
})


export class DlaComponent implements OnInit {

  page: Object;
  
  constructor(private contentService: ContentService, private modalService: BsModalService) { 
  }

  ngOnInit() {
    this.page = this.contentService.pages['dla-code'];
  }

  modalRef: BsModalRef;
 
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: 'static',
      class: 'modal-fluid'
    });
  }

}
